import React, { useRef, useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { SimpleCloseIcon } from "../../../../../assets/Logos/Icons";
import styles from "./index.module.scss";
import Textarea from "react-expanding-textarea";

function AddDataModal({ showModal, hidemodal, title, onSubmit }) {
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const inputRef = useRef();

  const handleSubmit = () => {
    if (name.trim()) {
      hidemodal();
      onSubmit && onSubmit({ name: name.trim(), isNew: true });
      setError("");
    } else {
      setError("Name is a required field !!!");
    }
  };

  const [textareaHeight, setTextareaHeight] = useState("auto");

  useEffect(() => {
    const textarea = document.getElementById("noteTextarea");
    if (textarea) {
      setTextareaHeight(`${textarea.scrollHeight}px`);
    }
  }, [name]);

  useEffect(() => {
    setName("");
    setError("");
  }, [showModal]);

  const handleChange = (e) => {
    const value = e.target.value;
    setName(value.substring(0, 50));
    setError("");
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain");
    const start = e.target.selectionStart;
    const end = e.target.selectionEnd;
    const currentValue = name;

    const availableSpace = 50 - (currentValue.length - (end - start));
    const truncatedPastedData = pastedData.substring(0, availableSpace);

    const newValue =
      currentValue.substring(0, start) +
      truncatedPastedData +
      currentValue.substring(end);

    setName(newValue.substring(0, 50));
    setError("");

    setTimeout(() => {
      const newCursorPosition = start + truncatedPastedData.length;
      inputRef.current.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);
  };

  return (
    <Modal
      key={showModal}
      closeButton
      show={showModal}
      onHide={hidemodal}
      className={styles.patient_consent_modal_align}
      backdrop="static"
    >
      <Modal.Body>
        <div className={styles.modalContent}>
          <div className={styles.closeBar} onClick={hidemodal}>
            <SimpleCloseIcon />
          </div>
          <div className={styles.title}>{title}</div>

          <div className={styles.form_item}>
            <div className={styles.form_item_caption}>Name</div>
            <div className={styles.textareaContainer}>
            <Textarea
              key={showModal}
              onChange={handleChange}
              onPaste={handlePaste}
              ref={inputRef}
              type="text"
              placeholder="Enter name here"
              value={name}
              className={styles.textarea}
              style={{ height: textareaHeight }}
               id="noteTextarea"
               maxLength={50}
            />
          </div>
          </div>
          {error && (
            <div className={styles.form_item}>
              <div className={styles.form_item_error}>{error}</div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Button
        disabled={!name.trim()}
        className={styles.patient_consent_accept_button}
        onClick={handleSubmit}
      >
        Save
      </Button>
    </Modal>
  );
}

export default AddDataModal;